import { render, staticRenderFns } from "./PrizeSource.vue?vue&type=template&id=083196e7&scoped=true&"
import script from "./PrizeSource.vue?vue&type=script&lang=js&"
export * from "./PrizeSource.vue?vue&type=script&lang=js&"
import style0 from "./PrizeSource.vue?vue&type=style&index=0&id=083196e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083196e7",
  null
  
)

export default component.exports